export default __webpack_public_path__ + "static/ondemand-84f1f3386dad083fe61d84423f2a3a87.png";